export const getInputFieldHeightValue = (themeMode, inputFieldHeight) => {
  if (inputFieldHeight) return inputFieldHeight;
  if (themeMode === "lodestar-light") return 40;
  return 32;
};
//# sourceMappingURL=inputFieldBaseProps.js.map